import { ApiProperty } from '@nestjs/swagger';
export class ItemIDRequest {

    @ApiProperty()
    itemId: number;
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    saleOrderId?: number;
    @ApiProperty()
    locationId?: number;
    @ApiProperty()
    saleOrderItemId?: number;
    @ApiProperty()
    stockType?: string;

}

